module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/figma-aa02299efaad6471581b63820e8a5809.jpg";